module.exports = __webpack_public_path__ + "80c6c10963f8be1e333ee6f7aeec5ca5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg2.jpeg
// module id = 28
// module chunks = 0